var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuteur2Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.962,
    height: 28.962,
    viewBox: "0 0 28.962 28.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 14.481,
    cy: 14.481,
    r: 14.481
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar-svgrepo-com",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 14.481,
    cy: 14.481,
    r: 14.481,
    transform: "translate(0.001 0)",
    fill: "#14b0bf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(6.279 8.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M46.524,105.44c-.933-1.767-6.935-2.876-6.935-2.876s-6,1.109-6.935,2.876c-.69,2.452-1.267,5.568-1.267,5.568h16.4A27.273,27.273,0,0,0,46.524,105.44Z",
    transform: "translate(-31.387 -90.163)",
    fill: "#f1c9a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M72.387,102.564s6,1.109,6.935,2.876a27.258,27.258,0,0,1,1.267,5.568h-8.2Z",
    transform: "translate(-64.185 -90.163)",
    fill: "#e4b692"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 3.268,
    height: 5.469,
    transform: "translate(6.568 8.809)",
    fill: "#f1c9a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 1.634,
    height: 5.469,
    transform: "translate(8.202 8.809)",
    fill: "#e4b692"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M64.22,87.14a2.575,2.575,0,0,0,2.351,1.327,2.937,2.937,0,0,0,.917-.149V84.606H64.22Z",
    transform: "translate(-57.652 -75.797)",
    fill: "#ddac8c",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M59.789,45.932c0-3.416-1.881-5.358-4.2-5.358s-4.2,1.942-4.2,5.358c0,4.594,1.881,6.185,4.2,6.185S59.789,50.335,59.789,45.932Z",
    transform: "translate(-47.386 -40.574)",
    fill: "#f1c9a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M85.525,65.669a1.51,1.51,0,0,1-1.147-1.832,1.633,1.633,0,0,1,1.611-1.545,1.509,1.509,0,0,1,1.146,1.832A1.633,1.633,0,0,1,85.525,65.669Z",
    transform: "translate(-73.761 -57.943)",
    fill: "#e4b692"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M46.606,64.125a1.509,1.509,0,0,1,1.146-1.832,1.633,1.633,0,0,1,1.611,1.545,1.51,1.51,0,0,1-1.147,1.832A1.633,1.633,0,0,1,46.606,64.125Z",
    transform: "translate(-43.546 -57.943)",
    fill: "#f1c9a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M76.588,45.932c0-3.416-1.881-5.358-4.2-5.358V52.117C74.707,52.117,76.588,50.335,76.588,45.932Z",
    transform: "translate(-64.185 -40.574)",
    fill: "#e4b692"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M46.524,107.616c-.545-1.032-2.817-1.839-4.614-2.332l-2.321,7.9-2.321-7.9c-1.8.493-4.069,1.3-4.614,2.332-.69,2.452-1.267,5.568-1.267,5.568h16.4A27.252,27.252,0,0,0,46.524,107.616Z",
    transform: "translate(-25.107 -84.221)",
    fill: "#0d313d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M60.413,105.284l2.4,7.9,2.33-7.9-2.33,2.653Z",
    transform: "translate(-48.327 -84.221)",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M72.387,113.184l3.547-3.95-1.217-.461,2.117-2.876-2.057-.613Z",
    transform: "translate(-57.906 -84.221)",
    fill: "#2b5770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M54.605,113.184l-3.547-3.95,1.217-.461L50.158,105.9l2.057-.613Z",
    transform: "translate(-40.124 -84.221)",
    fill: "#2b5770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M57.359,107.773l1.816-1.688,1.187,1.13-1.631-2.833-1,.077C57.664,105.56,57.359,107.773,57.359,107.773Z",
    transform: "translate(-45.884 -83.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M75.375,107.773l-1.816-1.688-1.188,1.13L74,104.382l1,.077C75.071,105.56,75.375,107.773,75.375,107.773Z",
    transform: "translate(-57.894 -83.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M59.062,41.249s-.749-.565-1.07,1.094c.1-1.559.028-3.709-1.237-4.1-.7,1.265-3.485,2.079-5.311,1.63a3.448,3.448,0,0,1-.759,2.923c.028-1.152.028-1.855-.7-1.63-.2-2.417,1.127-5.48,4.7-5.48S59.428,38.1,59.062,41.249Z",
    transform: "translate(-39.968 -28.544)",
    fill: "#262421"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuteur2Icon);
export default __webpack_public_path__ + "static/media/auteur-2-icon.10d16a458425078ca14ad9d30fcd1041.svg";
export { ForwardRef as ReactComponent };